import React from "react";
import PropTypes from "prop-types";
import Toast from "@/components/Toast/Toast";
import ToastExpandible from "@/components/Toast/ToastExpandible";
import PredioSelector from "@/components/Predios/PredioSelector";
import { toTitleCase } from "@/utils/strings";

const Step2 = (props) => {
  const { user, mapRef, selectedPredio, setSelectedPredio } = props;

  const handlePredioSeleccionado = (predio) => {
    if (!predio) return;
    setSelectedPredio(predio);
  };

  return (
    <div className="flex flex-col gap-4">
      <Toast
        visible={selectedPredio == null}
        message="A continuación, seleccione uno de sus predios para realizar la solicitud de Liquidación de Alcabalas"
        type="info"
      />

      <ToastExpandible
        visible={selectedPredio != null}
        type="success"
        message="Predio Seleccionado"
        submessage="Haga click para obtener mas detalles"
      >
        <ul className="list-disc pl-6">
          <li>
            <strong>Clave predial:</strong> {selectedPredio?.clave ?? ""}
          </li>
          <li>
            <strong>Parroquia:</strong>Parroquia:{" "}
            {toTitleCase(selectedPredio?.nombreparroquia ?? "")}
          </li>
          <li>
            <strong>Barrio:</strong>{" "}
            {toTitleCase(selectedPredio?.nombrebarrio ?? "")}
          </li>
          <li>
            <strong>Dirección:</strong>{" "}
            {toTitleCase(selectedPredio?.Direccion ?? "")}
          </li>
        </ul>
      </ToastExpandible>

      <PredioSelector
        user={user}
        onChange={handlePredioSeleccionado}
        mapRef={mapRef}
        enableSearchClickMap={false}
        enableSearchMap={false}
        enableDrawerMap={true}
      />
    </div>
  );
};

Step2.propTypes = {
  user: PropTypes.object.isRequired,
  mapRef: PropTypes.object,
  selectedPredio: PropTypes.shape({
    clave: PropTypes.string,
    nombreparroquia: PropTypes.string,
    nombrebarrio: PropTypes.string,
    Direccion: PropTypes.string,
  }),
  setSelectedPredio: PropTypes.func.isRequired,
};

export default Step2;
